export default "__VITE_ASSET__D3zacrR4__"